var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRhombus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM11.2929 7.05025L7.05025 11.2929C6.65972 11.6834 6.65972 12.3166 7.05025 12.7071L11.2929 16.9497C11.6834 17.3403 12.3166 17.3403 12.7071 16.9497L16.9497 12.7071C17.3403 12.3166 17.3403 11.6834 16.9497 11.2929L12.7071 7.05025C12.3166 6.65973 11.6834 6.65973 11.2929 7.05025Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRhombus);
export default __webpack_public_path__ + "static/media/rhombus.eff045476bcd5261dba08ce4995fe60c.svg";
export { ForwardRef as ReactComponent };